<div class="choosegroup dropdown group-filter-dropdown" [class.opened]="isOpen" (click)="toggleDropdown($event)">
  <input type="text" readonly="readonly" placeholder="{{'Choose group'|translate}}" (input)="onTermChange($event)"
    [(ngModel)]="selectedGroup.Name" />
  <div class="dropcontent dontclose">
    <div class="dropcontentinset">
      <button class="btnaddgroup" (click)="addGroup()" *ngIf="isEditable && canAddGroup">{{'Add group'|translate
        }}</button>
      <input type="text" class="searchinput" placeholder="{{'Find group'|translate}}" [(ngModel)]="groupNameFilter" />
      <div class="group-filter-list">
        <div class="spanitem" [class.activegroup]="selectedGroup == allGroupsItem" (click)="selectGroup(allGroupsItem)">
          <div class="group-text">
            <span class="group-name" [title]="allGroupsItem.Name">{{allGroupsItem.Name}}</span>
          </div>
          <span class="group-count"></span>
        </div>
        <div [class.activegroup]="selectedGroup == group" class="spanitem"
          *ngFor="let group of groups | filterByName : groupNameFilter">
          <div class="group-text" (click)="selectGroup(group)">
            <span class="group-name" [title]="group.Name">{{group.Name}}</span>
            <span class="group-company" *ngIf="getGroupCompanyName(group)" [title]="getGroupCompanyName(group)">
              {{getGroupCompanyName(group)}}
            </span>
          </div>
          <span class="group-count">{{group.Count}}</span>
          <div class="dropdown" *ngIf="isEditable">
            <button class="btn_moregray" (click)="openMgmtDropdown(group,$event)"></button>
            <div class="group-mgmt-menu" *ngIf="group.isMgmtOpen" [style.display]="group.isMgmtOpen ? 'block':'none'"
              [style.left.px]="group.mgmtxPos" [style.top.px]="group.mgmtyPos">
              <div class="group-mgmt-menu-item" [class.disabled]="!isEditAllowed(group)"
                (click)="isEditAllowed(group) && editGroup(group)">
                {{'Edit'|translate }}
              </div>
              <div class="separator"></div>
              <div class="group-mgmt-menu-item red" [class.disabled]="!isDeleteAllowed(group)"
                (click)="isDeleteAllowed(group) && deleteGroup(group)">
                {{'Delete'|translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
